/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Col_PriceInputs */

const en_pc_alt_col_price = /** @type {(inputs: Pc_Alt_Col_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price`)
};

const zh_pc_alt_col_price = /** @type {(inputs: Pc_Alt_Col_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`价格`)
};

/**
* | output |
* | --- |
* | "Price" |
*
* @param {Pc_Alt_Col_PriceInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_col_price = /** @type {((inputs?: Pc_Alt_Col_PriceInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Col_PriceInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_col_price(inputs)
	return zh_pc_alt_col_price(inputs)
});
export { pc_alt_col_price as "pc.alt.col.price" }